//
// Acknowledgement Acknowledgement
// --------------------------------------------------
// JS to close acknowledgement on escape key or close button press

window.addEventListener('load', () => {
    let main = document.querySelector('main');
    let acknowledgement = document.querySelector('.acknowledgement-overlay');

    if (acknowledgement && main) {
        let acknowledgeExit = acknowledgement.querySelector('button[data-acknowledgement-close]');
        main.classList.add('ios-vh-fix');

        function acknowledgementAcknowledged() {
            main.dataset.acknowledgment = 'true';
            main.classList.remove('ios-vh-fix');
            main.removeAttribute('style');
        }

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") {
                acknowledgementAcknowledged()
            }
        });

        if (acknowledgeExit) {
            acknowledgeExit.addEventListener('click', () => {
                acknowledgementAcknowledged();
            });
        }
    }
});
